import { setTime, setUserToken, setSessionData, setTokenInfo } from '@/auth/authUtil';
import { MOBILE_PATTERN } from '@/components/validatePatterns';
import { sendFreuence } from '@/config';
import { setUser } from '@/redux/reducer';
import { Iuser, ModalPageRef } from '@/typings';
import { ElForm, ElInput, ElButton, useForm, ElMessage, ElNotification, FormRules, isNotEmpty, ElDialog, ElIcon, ElLoading } from '@qsxy/element-plus-react';
import React, { forwardRef, useCallback, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { register, sendVerificationCode } from '../register/api';
import { bindWechatId, loginByPhone } from './api';
import classNames from 'classnames';

const BindWechat = forwardRef<ModalPageRef<any>, any>((_, ref) => {
	const [logining, setLogining] = useState(false);
	const [loginText, setLoginText] = useState('登录');
	const [visible, setVisible] = useState(false);
	const [bindExist, setBindExist] = useState(false);

	const [formInstance] = useForm<Iuser>();
	const dispatch = useDispatch();

	const timeOutRef = useRef(sendFreuence);
	const buttonRef = useRef<HTMLSpanElement>(null);
	const openIdRef = useRef<string>(null);

	const [disabled, setDisabled] = useState(false);

	const navigate = useNavigate();

	const rules = useMemo<FormRules>(() => {
		return {
			phoneNumber: [
				{ required: true, message: '请填写手机号' },
				{ len: 11, message: '请填写11位长度手机号' },
				{ pattern: MOBILE_PATTERN, message: '手机号格式不正确' },
			],
			code: [{ required: true, message: '请填写验证码' }],
		};
	}, []);

	const startTimeout = () => {
		setDisabled(true);
		buttonRef.current.innerText = timeOutRef.current + 's';
		setTime(timeOutRef.current);
		const stop = setInterval(() => {
			timeOutRef.current = timeOutRef.current - 1;
			setTime(timeOutRef.current);
			if (timeOutRef.current <= 0) {
				timeOutRef.current = sendFreuence;
				setTime(sendFreuence);
				clearInterval(stop);
				setDisabled(false);
				buttonRef.current.innerText = '发送验证码';
			} else {
				buttonRef.current.innerText = timeOutRef.current + 's';
			}
		}, 1000);
	};

	const onLoginByPhone = useCallback(() => {
		formInstance.validateFields().then(values => {
			setLogining(true);
			setLoginText('正在登录中...');
			bindWechatId({ wechatId: openIdRef.current, username: values.phoneNumber })
				.then(result => {
					setLogining(false);
					ElNotification.closeAll();
					setLoginText('登录成功，正在进入系统...');
					const { data } = result;

					setTimeout(() => {
						const { token, user } = data;
						setUserToken();
						setSessionData(data);
						setTokenInfo(token);
						dispatch(setUser(user));
						navigate('/chat');
					}, 500);
				})
				.catch(({ message }) => {
					if (isNotEmpty(message)) {
						ElMessage.error({ message: message, grouping: true });
					}
					setLogining(false);
					setLoginText('登录');
				});
		});
	}, [dispatch, formInstance, navigate]);

	const onRegister = useCallback(() => {
		formInstance.validateFields().then(values => {
			const load = ElLoading.service();
			const shareFrom = sessionStorage.getItem('shareFrom');
			register({ ...values, username: values.phoneNumber, vertionType: '0', password: '', email: '', wechatId: openIdRef.current, from: shareFrom })
				.then(() => {
					load.close();
					ElNotification.closeAll();
					// ElMessage.success({
					// 	message: '注册成功，即将跳转至首页',
					// 	// duration: 1500,
					// 	onClose() {
					// 		navigate('/chat');
					// 	},
					// });
					onLoginByPhone();
					if (shareFrom) {
						sessionStorage.removeItem('shareFrom');
					}
				})
				.catch(({ message }) => {
					if (isNotEmpty(message)) {
						ElMessage.error({ message: message, grouping: true });
					}
					load.close();
				});
		});
	}, [formInstance, onLoginByPhone]);

	const sendCode = () => {
		formInstance.validateFields(['phoneNumber']).then(user => {
			sendVerificationCode({ type: 'phone', identifier: user.phoneNumber })
				.then(msg => {
					ElMessage.success(msg);
					startTimeout();
				})
				.catch(msg => ElMessage.error(msg));
		});
	};

	const onEnter = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement>) => {
			if (event.key === 'Enter') {
				bindExist ? onLoginByPhone() : onRegister();
			}
		},
		[bindExist, onLoginByPhone, onRegister],
	);

	useImperativeHandle(ref, () => ({
		open(openId: string) {
			openIdRef.current = openId;
			setVisible(true);
		},
	}));

	return (
		<ElDialog title="" width={480} visible={visible} close={() => setVisible(false)}>
			<div className="ttn-bind-wechat">
				{bindExist ? (
					<ElButton
						type="info"
						text
						className="ttn-back"
						onClick={() => {
							setBindExist(false);
							formInstance.resetFields();
						}}
					>
						<ElIcon name="angle-left" /> 返回
					</ElButton>
				) : null}
				<div className={classNames('title', { 'account-title': bindExist })}>{bindExist ? '绑定已有气候脉搏账号' : '用户注册登录'}</div>
				<ElForm labelPosition="top" className="ttn-login-form" form={formInstance} size="large" rules={rules}>
					{bindExist ? null : <p className="form-item-title">为了给您提供更好的服务，请绑定手机号</p>}
					<ElForm.Item name="phoneNumber" validateTrigger="onBlur">
						<ElInput placeholder="输入手机名" onKeyDown={onEnter} autoFocus />
					</ElForm.Item>
					<ElForm.Item name="code">
						{({ value, onChange }) => (
							<ElInput
								placeholder="输入验证码"
								suffix={
									<ElButton type="primary" link disabled={disabled} onClick={sendCode}>
										<span ref={buttonRef}>发送验证码</span>
									</ElButton>
								}
								showPassword
								onKeyDown={onEnter}
								value={value}
								onChange={onChange}
							/>
						)}
					</ElForm.Item>
					<ElForm.Item pure center className="ttn-login-btn">
						<ElButton type="primary" block onClick={bindExist ? onLoginByPhone : onRegister} loading={logining}>
							{loginText}
						</ElButton>
					</ElForm.Item>

					{bindExist ? null : (
						<ElForm.Item pure center className="ttn-login-btn">
							<ElButton
								type="primary"
								link
								onClick={() => {
									setBindExist(true);
									formInstance.resetFields();
								}}
							>
								绑定已有气候脉搏账号
							</ElButton>
						</ElForm.Item>
					)}
				</ElForm>
			</div>
		</ElDialog>
	);
});

export default BindWechat;
